export const recordVersionChange = async ({ config, eventLog, getBuildMetadata }) => {
  const versionHistoryEvents = await eventLog.getVersionHistory()
  const { version: currentVersion } = await getBuildMetadata()

  const latestVersionEvent = versionHistoryEvents[versionHistoryEvents.length - 1]

  if (currentVersion === latestVersionEvent?.version) {
    return
  }

  await eventLog.record({
    event: config.versionHistoryEventName,
  })
}

const createEventLogLifecyclePlugin = ({ config, getBuildMetadata, eventLog }) => {
  const onStart = () => {
    void recordVersionChange({ config, eventLog, getBuildMetadata })
  }

  return { onStart }
}

export default createEventLogLifecyclePlugin
